import React from 'react'
import WOW from 'react-wow'
import {Col} from '@bootstrap-styled/v4'

import PortfolioItem from 'src/components/ui/PortfolioItem'

const Hit = ({hit}) => {
    return (
        <WOW animation="fadeIn" key={hit.slug}>
            <Col xs={12} lg={6}>
                <PortfolioItem
                    slug={hit.fields.slug}
                    title={hit.title}
                    category={hit.category}
                    img={hit.image}/>
            </Col>
        </WOW>
    )
}

export default Hit